function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Color from "terriajs-cesium/Source/Core/Color";
import ColorMap from "./ColorMap";
export default class ContinuousColorMap extends ColorMap {
  constructor(options) {
    super();
    _defineProperty(this, "colorScale", void 0);
    _defineProperty(this, "nullColor", void 0);
    _defineProperty(this, "outlierColor", void 0);
    _defineProperty(this, "minValue", void 0);
    _defineProperty(this, "maxValue", void 0);
    _defineProperty(this, "isDiverging", void 0);
    _defineProperty(this, "colorMapMinValue", void 0);
    _defineProperty(this, "colorMapMaxValue", void 0);
    if (options.minValue === options.maxValue) {
      throw "Minimum and maximum values must be different.";
    }
    if (options.minValue > options.maxValue) {
      throw "Minimum value must be less than the maximum value.";
    }
    this.colorScale = options.colorScale;
    this.nullColor = options.nullColor;
    this.outlierColor = options.outlierColor;
    this.minValue = options.minValue;
    this.maxValue = options.maxValue;
    this.isDiverging = options.isDiverging;

    // If color scale is diverging
    // We want Math.abs(minValue) === Math.abs(maxValue)
    // This is so the neutral color in the middle of the color map (usually white) is at 0
    if (this.isDiverging) {
      this.colorMapMinValue = this.minValue;
      this.colorMapMaxValue = this.maxValue;
      if (-this.colorMapMinValue > this.colorMapMaxValue) {
        this.colorMapMaxValue = -this.colorMapMinValue;
      } else {
        this.colorMapMinValue = -this.colorMapMaxValue;
      }
    } else {
      this.colorMapMinValue = this.minValue;
      this.colorMapMaxValue = this.maxValue;
    }
  }
  mapValueToColor(value) {
    var _this$outlierColor, _this$outlierColor2;
    if (typeof value !== "number") {
      return this.nullColor;
    }

    // Handle value larger than maxValue
    if (value > this.maxValue) return (_this$outlierColor = this.outlierColor) !== null && _this$outlierColor !== void 0 ? _this$outlierColor : Color.fromCssColorString(this.colorScale(1));

    // Handle value smaller than minValue
    if (value < this.minValue) return (_this$outlierColor2 = this.outlierColor) !== null && _this$outlierColor2 !== void 0 ? _this$outlierColor2 : Color.fromCssColorString(this.colorScale(0));
    return Color.fromCssColorString(this.colorScale((value - this.colorMapMinValue) / (this.colorMapMaxValue - this.colorMapMinValue)));
  }
}